import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { ecommerceServer } from "../../server";
import { useSelector } from "react-redux";
import {
  IMAGE_ACCEPT_WITH_HEIC,
  getImagePreparationErrorMessage,
  prepareImageFileForUpload,
} from '../../utils/imageUploadPreparation';

const BrandCreate = () => {
  const { seller } = useSelector((state) => state.seller);
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [coverImage, setCoverImage] = useState(null);
  const [avatarImage, setAvatarImage] = useState(null);
  const [coverImagePreview, setCoverImagePreview] = useState(null);
  const [avatarImagePreview, setAvatarImagePreview] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append('name', name);
    formData.append('description', description);
    if (coverImage) formData.append('coverImage', coverImage);
    if (avatarImage) formData.append('avatarImage', avatarImage);

    try {
      const response = await axios.post(`${ecommerceServer}/brand/create-brand`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'current-profile': seller.name || 'defaultProfile',
        },
        withCredentials: true,
      });
      if (response.data.success) {
        toast.success('Brand created successfully!');
        setName('');
        setDescription('');
        setCoverImage(null);
        setAvatarImage(null);
        setCoverImagePreview(null);
        setAvatarImagePreview(null);
      } else {
        toast.error('Brand creation failed.');
      }
    } catch (error) {
      console.error('Error creating brand:', error);
      toast.error('Failed to create brand.');
    }
  };

  const prepareBrandImage = async (event, setImage, setPreview) => {
    const file = event.target.files?.[0];
    event.target.value = '';

    if (!file) {
      return;
    }

    try {
      const preparedFile = await prepareImageFileForUpload(file);
      setImage(preparedFile);
      setPreview(URL.createObjectURL(preparedFile));
    } catch (error) {
      console.error('Error preparing brand image:', error);
      toast.error(getImagePreparationErrorMessage(error));
    }
  };

  const handleCoverImageChange = (e) => {
    prepareBrandImage(e, setCoverImage, setCoverImagePreview);
  };

  const handleAvatarImageChange = (e) => {
    prepareBrandImage(e, setAvatarImage, setAvatarImagePreview);
  };

  return (
    <div className="brand-create-component-container">
      <form onSubmit={handleSubmit} className="brand-create-component-form">
        <div className="brand-create-component-form-group">
          <label htmlFor="name" className="brand-create-component-label">
            Name
          </label>
          <input
            id="name"
            name="name"
            type="text"
            required
            className="brand-create-component-input"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>

        <div className="brand-create-component-form-group">
          <label htmlFor="description" className="brand-create-component-label">
            Description
          </label>
          <textarea
            id="description"
            name="description"
            rows={4}
            className="brand-create-component-textarea"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          ></textarea>
        </div>

        <div className="brand-create-component-form-group">
          <label htmlFor="coverImage" className="brand-create-component-label">
            Cover Image
          </label>
          <input
            id="coverImage"
            name="coverImage"
            type="file"
            accept={IMAGE_ACCEPT_WITH_HEIC}
            className="brand-create-component-file-input"
            onChange={handleCoverImageChange}
          />
          {coverImagePreview && (
            <img
              src={coverImagePreview}
              alt="Cover Preview"
              className="brand-create-component-image-preview"
            />
          )}
        </div>

        <div className="brand-create-component-form-group">
          <label htmlFor="avatarImage" className="brand-create-component-label">
            Avatar Image
          </label>
          <input
            id="avatarImage"
            name="avatarImage"
            type="file"
            accept={IMAGE_ACCEPT_WITH_HEIC}
            className="brand-create-component-file-input"
            onChange={handleAvatarImageChange}
          />
          {avatarImagePreview && (
            <img
              src={avatarImagePreview}
              alt="Avatar Preview"
              className="brand-create-component-image-preview"
            />
          )}
        </div>

        <button type="submit" className="brand-create-component-submit-button">
          Create Brand
        </button>
      </form>
    </div>
  );
};

export default BrandCreate;


